import { Line } from '@react-three/drei';
import ProductClearanceLabel from './ProductClearanceLabel';
import { useNavigation } from '../../function/navigation';
import { UnitConversion } from '../../inputs/UnitConversion';

function LowerEndView({
  result,
  convRatio,
  drawingBaseDimensions,
  unitSystem,
}) {
  const { nav } = useNavigation();
  const d = drawingBaseDimensions;

  const z = convRatio * d.column_centre_to_inside_outer_guide * 1.1;
  const targetY = convRatio * d.h1;
  const textSize = 20 / d.nbr_windings;

  const isReverse = ['A', 'C', 'E', 'G', 'L'].includes(d.configuration);
  const reverseMultiplier = isReverse ? 1 : -1;

  const l1 = convRatio * d.l1 * reverseMultiplier;
  const leAngular = convRatio * d.le_angular * reverseMultiplier;
  const leDoubleBend = convRatio * d.le_double_bend_value * reverseMultiplier;
  const l2 = convRatio * d.l2_value * reverseMultiplier;

  const renderLine = (start, end, verticalOffset, color) => (
    <Line
      points={[
        [start, verticalOffset, z],
        [end, verticalOffset, z],
      ]}
      color={color}
      lineWidth={3}
    />
  );

  const renderValueLabel = (x, y, value, color, field) => {
    const { displayedValue } = UnitConversion(value, unitSystem, 'mm');
    return (
      <group position={[x, y, z]}>
        <ProductClearanceLabel
          value={displayedValue}
          reverseConfig={-1}
          textSize={textSize}
          color={color}
          focus={nav.focusedInput === field}
        />
      </group>
    );
  };

  return (
    <group rotation={[0, Math.PI / 2, 0]} position={[0, targetY, 0]}>
      {renderLine(0, l1, 0.1 * textSize, 'OrangeRed')}

      {leAngular &&
        leAngular !== l1 &&
        renderLine(0, leAngular, 0, 'DarkViolet')}

      {leDoubleBend &&
        renderLine(leAngular, leAngular + leDoubleBend, 0, 'DodgerBlue')}

      {l2 &&
        l2 !== l1 &&
        renderLine(leAngular + leDoubleBend, l1, 0, 'SeaGreen')}

      {renderValueLabel(l1 / 2, 0.1 * textSize, result.l1, 'OrangeRed', 'l1')}
      {leAngular &&
        leAngular !== l1 &&
        renderValueLabel(
          leAngular / 2,
          0,
          result.le_angular,
          'DarkViolet',
          'le_angular'
        )}
      {leDoubleBend &&
        renderValueLabel(
          leAngular + leDoubleBend / 2,
          0,
          result.le_double_bend_value,
          'DodgerBlue',
          'le_double_bend_value'
        )}
      {l2 &&
        l2 !== l1 &&
        renderValueLabel(
          leAngular + leDoubleBend + l2 / 2,
          0,
          result.l2_value,
          'SeaGreen',
          'l2_value'
        )}
    </group>
  );
}

export default LowerEndView;
